export default __webpack_public_path__ + "static/media/emoji-money2.6ad73289.svg";